import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import NavbarDropdown from './NavbarDropdown';

import {
  panelRoutes,
  asuntosRoutes,
  etiquetasRoutes,
  stockRoutes,
  gestionRoutes,
  clientesRoutes,
  proveedoresRoutes
} from '../../routes';
import { breakpoints, getPageName } from '../../helpers/utils';
import { navbarBreakPoint, topNavbarBreakpoint } from '../../config';
import AppContext from '../../context/Context';

const NavbarTopDropDownMenus = ({ setNavbarCollapsed, setShowBurgerMenu }) => {
  const { isCombo, isTopNav } = useContext(AppContext);

  const pages = [panelRoutes, asuntosRoutes, etiquetasRoutes, stockRoutes, gestionRoutes, clientesRoutes, proveedoresRoutes];

  const handleSetNavbarCollapsed = () => {
    const windowWidth = window.innerWidth;
    isTopNav && !isCombo && windowWidth < breakpoints[topNavbarBreakpoint] && setNavbarCollapsed(false);
    isCombo && windowWidth < breakpoints[navbarBreakPoint] && setShowBurgerMenu(false);
  };
  return (
      <NavbarDropdown title={panelRoutes.name} items={pages} handleSetNavbarCollapsed={handleSetNavbarCollapsed} />
  );
};

NavbarTopDropDownMenus.propTypes = { setNavbarCollapsed: PropTypes.func.isRequired };

export default NavbarTopDropDownMenus;
